import type {
  AutoConfigCellRendererProps,
  ConfigData,
  DeliveryConfigCellRendererParams,
  DeliveryReconSiteOverviewRow,
} from './types'
import type { ColDef } from 'ag-grid-community'

import { BBDTag } from '@gravitate-js/excalibrr'
import { isCustomConfig } from './util'

function AutoConfigCellRenderer({ params, onClick }: AutoConfigCellRendererProps) {
  if (!params.data) return null
  return (
    <BBDTag
      theme2={params.value === 'Custom'}
      onClick={() => params?.data && onClick(params.data)}
      style={{ cursor: 'pointer' }}
    >
      {params.value}
    </BBDTag>
  )
}

export function getColumnDefs(
  configData: ConfigData,
  onClickConfig: (row: DeliveryReconSiteOverviewRow) => void
): ColDef[] {
  return [
    {
      field: 'store',
      headerName: 'Site',
      comparator: (a, b) => Number(a) - Number(b),
    },
    {
      field: 'product',
      headerName: 'Tank Product',
    },
    {
      headerName: 'Auto Match Config',
      valueGetter: (params) => (isCustomConfig(params.data, 'match', configData) ? 'Custom' : 'Global'),
      cellRenderer: (params: DeliveryConfigCellRendererParams) => (
        <AutoConfigCellRenderer params={params} onClick={onClickConfig} />
      ),
    },
    {
      headerName: 'Auto Approve Config',
      valueGetter: (params) => (isCustomConfig(params.data, 'approve', configData) ? 'Custom' : 'Global'),
      cellRenderer: (params: DeliveryConfigCellRendererParams) => {
        return <AutoConfigCellRenderer params={params} onClick={onClickConfig} />
      },
    },
  ]
}
